export default __webpack_public_path__ + "static/media/peopleResponsive_es.c1cce3ab.png";